var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"live-page"},[_c('div',{staticStyle:{"margin":"0px auto"},attrs:{"id":"video-container"}})])}]

export { render, staticRenderFns }